'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDebouncedCallback;

var _react = require('react');

function useDebouncedCallback(callback, delay, deps) {
  var functionTimeoutHandler = (0, _react.useRef)(null);
  var debouncedFunction = (0, _react.useCallback)(callback, deps);

  (0, _react.useEffect)(function () {
    return function () {
      clearTimeout(functionTimeoutHandler.current);
    };
  }, []);

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(functionTimeoutHandler.current);
    functionTimeoutHandler.current = setTimeout(function () {
      debouncedFunction.apply(undefined, args);
    }, delay);
  };
}